import React from "react"
import styled from "styled-components"
import { rem } from "polished"
import { media } from "@sr/common"
import ProductHubListItem from "../../Section/Products/ProductsHubListItem"
import { IconName } from "@sr/gatsby-theme-ui/typedefs/components/Icon/iconTypes"

interface ProductsHubListContainerProps {
  productList: [
    {
      body: string
      features: [string]
      product: {
        id: string
        title: string
        path: {
          current: string
        }
        icon: IconName
        hero: {
          on: boolean
          secondaryButtonLinkType: "internal" | "tourial" | "none"
          tourialId: string
        }
        video: {
          url: string
          displayVideo: boolean
        }
      }
    }
  ]
}

const ProductHubListContainer = ({
  productList,
}: ProductsHubListContainerProps) => {
  if (!productList?.length) return null
  return (
    <ProductHubListContainerStyled id="solutions-list">
      {productList.length &&
        productList.map((listProps, index) => (
          <ProductHubListItem key={index} listProps={listProps} />
        ))}
    </ProductHubListContainerStyled>
  )
}

export default ProductHubListContainer

const ProductHubListContainerStyled = styled.section`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  width: 100%;
  padding: ${rem(48)} ${rem(16)} 0;
  grid-gap: ${rem(40)};
  max-width: ${rem(1440)};

  @media ${media.midUp} {
    padding: ${rem(72)} ${rem(64)} 0;
  }

  @media ${media.stMidUp} {
    grid-template-columns: repeat(2, 1fr);
    align-items: stretch;
    padding-bottom: ${rem(88)};
    grid-gap: ${rem(48)};
  }
`
